/// Menu
// import Metismenu from "metismenujs";
import React, { useReducer, useContext, useEffect, useState } from "react";
/// Scroll
import { Collapse } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { AdminMenuList, MenuList, StudentMenuList, TutorMenuList } from "./Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { useSelector } from "react-redux";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const [menuItems, setMenuItems] = useState([]);
  const { role } = useSelector((state) => state.auth);
  useEffect(() => {
    switch (role) {
      case "Tutor":
        setMenuItems(TutorMenuList);
        break;
      case "Student":
        setMenuItems(StudentMenuList);
        break;
      case "Admin":
      case "nkenne":
        setMenuItems(AdminMenuList);
        break;
      default:
        break;
    }
  }, []);
  const { iconHover, sidebarposition, headerposition, sidebarLayout, ChangeIconSidebar } =
    useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  const location = useLocation();

  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu

  useEffect(() => {
    const currentPath = location.pathname.slice(1); // Remove leading slash
    menuItems.forEach((menuItem) => {
      // Check if the current path matches the main menu item
      if (menuItem.to === currentPath) {
        setState({ active: menuItem.title, activeSubmenu: "" });
        return;
      }

      // Check submenus if they exist
      if (menuItem.content) {
        menuItem.content.forEach((submenuItem) => {
          // Check if current path matches submenu item
          if (submenuItem.to === currentPath) {
            setState({
              active: menuItem.title,
              activeSubmenu: submenuItem.title,
            });
            return;
          }

          // Check nested submenus if they exist
          if (submenuItem.content) {
            submenuItem.content.forEach((nestedItem) => {
              if (nestedItem.to === currentPath) {
                setState({
                  active: menuItem.title,
                  activeSubmenu: submenuItem.title,
                });
              }
            });
          }
        });
      }
    });
  }, [location.pathname, menuItems]);

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <div className="dlabnav-scroll">
        <ul
          className="metismenu"
          id="menu"
        >
          {menuItems.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li
                  className={menuClass}
                  key={index}
                >
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={`${state.active === data.title ? "mm-active" : ""} `}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow"
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                        <span className="ms-1 badge badge-xs style-1 badge-danger">
                          {data.update}
                        </span>
                      </Link>
                      <Collapse in={state.active === data.title}>
                        <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                          {data.content &&
                            data.content.map((data, index) => {
                              return (
                                <li
                                  key={index}
                                  className={`${
                                    state.activeSubmenu === data.title ? "mm-active" : ""
                                  }`}
                                >
                                  {data.content && data.content.length > 0 ? (
                                    <>
                                      <Link
                                        to={data.to}
                                        className={data.hasMenu ? "has-arrow" : ""}
                                        onClick={() => {
                                          handleSubmenuActive(data.title);
                                        }}
                                      >
                                        {data.title}
                                      </Link>
                                      <Collapse in={state.activeSubmenu === data.title}>
                                        <ul
                                          className={`${
                                            menuClass === "mm-collapse" ? "mm-show" : ""
                                          }`}
                                        >
                                          {data.content &&
                                            data.content.map((data, index) => {
                                              return (
                                                <li key={index}>
                                                  <Link
                                                    className={`${
                                                      path === data.to ? "mm-active" : ""
                                                    }`}
                                                    to={data.to}
                                                  >
                                                    {data.title}
                                                  </Link>
                                                </li>
                                              );
                                            })}
                                        </ul>
                                      </Collapse>
                                    </>
                                  ) : (
                                    <Link
                                      to={data.to}
                                      className={`${data.to === path ? "mm-active" : ""}`}
                                    >
                                      {data.title}
                                    </Link>
                                  )}
                                </li>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link
                      to={data.to}
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                      className={`${data.to === path ? "mm-active" : ""}`}
                    >
                      {data.iconStyle}
                      <span
                        className={`${state.active === data.title ? "mm-active" : ""} nav-text `}
                      >
                        {data.title}
                      </span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
